import type { FeedbackMessages } from './en';

const vi: FeedbackMessages = {
  qualified: {
    title: 'Cảm ơn bạn đã hoàn thành khảo sát này!',
    text: 'Bạn có thể đóng cửa sổ trình duyệt này.\n\nChúng tôi hy vọng sẽ sớm gặp lại bạn.',
  },
  quotaFull: {
    title: 'Khảo sát này đã đóng',
    text: 'Cảm ơn bạn đã quan tâm đến khảo sát của chúng tôi.\n\nRất tiếc, chúng tôi đã nhận được đủ số lượng phản hồi cần thiết.\n\nChúng tôi hy vọng sẽ được gặp bạn trong một trong những khảo sát sắp tới của chúng tôi!',
  },
  terminated: {
    title: 'Cảm ơn bạn đã chia sẻ ý kiến phản hồi!',
    text: 'Chúng tôi hy vọng sẽ sớm gặp lại bạn trong các khảo sát sắp tới. Trước mắt, chúc bạn một ngày tốt lành.\n\nVui lòng đóng cửa sổ trình duyệt này.',
  },
  mismatch: {
    title: 'Cảm ơn sự quan tâm của bạn',
    text: 'Rất tiếc, bạn không thuộc nhóm đối tượng mục tiêu của khảo sát này.\n\nBạn có thể đóng trang này.',
  },
  error: {
    title: 'Chúng tôi không thể xử lý yêu cầu của bạn',
    linkProblemDetailed:
      'Đường liên kết bạn vừa truy cập đang gặp vấn đề. Vui lòng kiểm tra xem đường liên kết trên thanh địa chỉ có khớp với đường liên kết đã được cung cấp cho bạn không, rồi thử lại.',
    linkProblemGeneric:
      'Đường liên kết bạn vừa truy cập đang gặp vấn đề. Vui lòng thử lại.',
    contactPerson:
      'Nếu vấn đề vẫn tiếp diễn, vui lòng thông báo cho người đã gửi đường liên kết này cho bạn về sự việc này.',
  },
};

export default vi;
